module.exports = __webpack_public_path__ + "u8.no2.3c32ec99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u8.no2.jpg
// module id = bVI5
// module chunks = 0